<templates>
	<button @click="addMethod" type="button" class="sm-button sm-edit-button" :class="class"><slot></slot></button>
</templates>

<script>
export default {
	props: ['method', 'content', 'className'],
	class: '',
	template: '<button @click="addMethod" type="button" class="sm-button sm-edit-button" :class="className"><slot></slot></button>',
	methods: {
		addMethod: function() {
			if (!this.content) {
				var method = '{[ ' + this.method + ' ]}';
				if ( /[\-]/.test( this.method ) ) {
					var method = '{[ attribute(atts, \'' + this.method + '\') ]}';	
				}
			} else {
				var method = '{@ ' + this.method + ' @}';
			}
			this.$emit('method', method);
		}
	}
};
</script>


// WEBPACK FOOTER //
// MethodButton.vue?640b1d9a